module.exports = __webpack_public_path__ + "videos/whats-new-53-colordrop_9x16.0039b95.mp4";